export default __webpack_public_path__ + "static/media/back.1ad61319.svg";